import React, { useState } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import NormalForm from "./NormalInvoice/NormalForm";
import SatNormalForm from "./SatNormalInvoice/SatNormalForm";
import { useLanguage } from "../../../Providers/LanguageContext";
import { useLocation } from "react-router-dom";

function InvoiceForm2({ getTime, value }) {
  const { language, currentLanguage } = useLanguage();
  const [invType, setInvType] = useState("");
  const location = useLocation();
  // console.log("invTypedd", invType);
  // console.log('location: ', location);
  
  return (
    <>
      <section className="invoiceFormTwoSec">
        <div className="myOwnFisiContainer">

          <div className="tabFisiContainer">
            <Tabs>
             <div className="myDivFisiTab">
                    {
                      location.pathname !== "/eventsCalender" && (
                        <TabList className="myFisiTab">
                      <Tab>Normal</Tab>
                      <Tab>SAT-Normal</Tab>
                      <Tab>SAT-Addenda</Tab>
                      <Tab>SAT-Substitute</Tab>
                    </TabList>
                      )
                    }
                  </div>
              <p className="creNewHead" style={{
                fontSize: '22px',
                fontWeight: '700',
                marginBottom: '20px'
              }}>Create new invoice</p>
              {/* normal form */}
              <TabPanel>
                <NormalForm
                  getTime={getTime}
                  value={value}
                />
              </TabPanel>

              {/* sat normal form */}
              <TabPanel>
                <SatNormalForm
                  getTime={getTime}
                  value={value}
                  setInvType={setInvType}
                />
              </TabPanel>

              <TabPanel>
                <h2>Any content 3</h2>
              </TabPanel>
              <TabPanel>
                <h2>Any content 4</h2>
              </TabPanel>
            </Tabs>

          </div>
        </div>
      </section>
    </>
  );
}

export default InvoiceForm2;
